import { render } from "./resourcesTable.vue?vue&type=template&id=4a9fe302"
import script from "./resourcesTable.vue?vue&type=script&lang=js"
export * from "./resourcesTable.vue?vue&type=script&lang=js"

import "./resourcesTable.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__